import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ logoSrc, logoWidth, logoHeight = 'auto', link }) => (
  <header className="ws-header">
    <div className="ws-header__inner">
      <a href={link} className="ws-header__logo">
        <img src={logoSrc} width={logoWidth} height={logoHeight} alt="Logo" />
      </a>
    </div>
  </header>
);

Header.propTypes = {
  link: PropTypes.string.isRequired,
  logoSrc: PropTypes.string.isRequired,
  logoWidth: PropTypes.number.isRequired,
  logoHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Header;
